/*
 * shopify-customizer.js — storefront mount for the license-plate customizer.
 * - Relocates the field above the Add to Cart buttons (inside the form); required.
 * - Live preview overlays the *visible* gallery image exactly; hidden until typing.
 * - Hides when a gallery thumbnail/arrow is clicked.
 * - Letters/numbers/spaces only, uppercased; values mirror into the add-to-cart form.
 * Depends on data.js (PLATES) and plate-engine.js.
 */
(function () {
  "use strict";

  function init() {
    var E = window.PlateEngine;
    var mount = document.getElementById("plate-customizer");
    if (!mount || !E || typeof PLATES === "undefined") return;

    var plate = PLATES.find(function (p) { return p.handle === mount.dataset.productHandle; });
    if (!plate) { mount.style.display = "none"; return; }

    var coverBox = mount.querySelector("[data-cover]");
    var coverArt = mount.querySelector("[data-art]");
    var canvas = mount.querySelector("[data-canvas]");
    var input = mount.querySelector("#plate-name-input");
    var errorEl = mount.querySelector(".plate-cust__error");

    var form = document.getElementById("AddToCartForm") ||
               document.querySelector('form[action*="/cart/add"]');

    if (form) {
      var anchor = form.querySelector(".btn-action") ||
                   form.querySelector("[data-add-to-cart]") ||
                   form.querySelector('[name="add"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(mount, anchor);
    }

    function ensureField(name) {
      if (!form) return null;
      var el = form.querySelector('input[name="properties[' + name + ']"]');
      if (!el) {
        el = document.createElement("input");
        el.type = "hidden";
        el.name = "properties[" + name + "]";
        form.appendChild(el);
      }
      return el;
    }
    var fCustom = ensureField("Custom Text");
    var fTemplate = ensureField("_Template");
    var fCode = ensureField("_Production Code");

    var galleryMain = document.querySelector(".product__gallery-main") ||
                      document.querySelector("product-gallery");
    var overlay;
    if (galleryMain) {
      if (getComputedStyle(galleryMain).position === "static") galleryMain.style.position = "relative";
      overlay = document.createElement("div");
      overlay.className = "plate-cust__gallery-overlay";
      overlay.appendChild(coverBox);
      galleryMain.appendChild(overlay);
    } else {
      overlay = coverBox;
    }
    function visibleImage() {
      if (!galleryMain) return null;
      var slide = galleryMain.querySelector(".splide__slide.is-active") ||
                  galleryMain.querySelector(".splide__slide") || galleryMain;
      var imgs = slide.querySelectorAll("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].offsetParent !== null && imgs[i].getBoundingClientRect().width > 2) return imgs[i];
      }
      return imgs[0] || galleryMain.querySelector("img");
    }
    function placeOverlay() {
      if (overlay === coverBox) return;
      var gr = galleryMain.getBoundingClientRect();
      var img = visibleImage();
      if (img) {
        var ir = img.getBoundingClientRect();
        overlay.style.top = (ir.top - gr.top) + "px";
        overlay.style.left = (ir.left - gr.left) + "px";
        overlay.style.width = ir.width + "px";
        overlay.style.height = ir.height + "px";
      } else {
        overlay.style.top = "0"; overlay.style.left = "0"; overlay.style.width = "100%"; overlay.style.height = gr.height + "px";
      }
    }
    function showPreview(on) {
      if (overlay === coverBox) { coverBox.style.display = on ? "" : "none"; return; }
      if (on) placeOverlay();
      overlay.classList.toggle("is-visible", on);
    }

    if (mount.dataset.fontUrl && document.fonts) {
      try {
        var face = new FontFace("LicensePlate", "url(" + mount.dataset.fontUrl + ")");
        face.load().then(function (f) { document.fonts.add(f); if (input.value.length) redraw(); }).catch(function () {});
      } catch (e) {}
    }

    coverArt.src = (mount.dataset.assetsBase || "") + plate.svg.split("/").pop();

    function redraw() {
      var rect = coverBox.getBoundingClientRect();
      if (!rect.height) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = Math.round(rect.width * dpr);
      var H = Math.round(rect.height * dpr);
      if (canvas.width !== W) canvas.width = W;
      if (canvas.height !== H) canvas.height = H;
      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, W, H);
      E.drawName(ctx, W, H, { text: input.value, color: plate.nameColor, geom: plate.geom });
    }

    function sync() {
      var info = E.productionCode(input.value || "");
      if (fCustom) fCustom.value = input.value || "";
      if (fTemplate) fTemplate.value = info.template;
      if (fCode) fCode.value = info.code;
    }

    function sanitize() {
      var clean = input.value.replace(/[^A-Za-z0-9 ]/g, "").toUpperCase();
      if (clean !== input.value) {
        var drop = input.value.length - clean.length;
        var pos = (input.selectionStart || clean.length) - drop;
        input.value = clean;
        try { input.setSelectionRange(pos, pos); } catch (e) {}
      }
    }

    function isValid() { return input.value.trim().length > 0; }
    function showError(on) { if (errorEl) errorEl.hidden = !on; }

    input.addEventListener("input", function () {
      sanitize();
      var has = input.value.length > 0;
      showPreview(has);
      if (has) { redraw(); showError(false); }
      sync();
    });
    window.addEventListener("resize", function () {
      if (input.value.length && overlay !== coverBox && overlay.classList.contains("is-visible")) {
        placeOverlay(); redraw();
      }
    });

    var gal = document.querySelector("product-gallery") || galleryMain;
    if (gal) {
      gal.addEventListener("click", function (e) {
        if (e.target.closest(".product__gallery-thumbnails") || e.target.closest(".splide__arrow")) showPreview(false);
      });
    }

    function guard(e) {
      if (!isValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(true);
        input.focus();
        try { input.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (x) {}
      }
    }
    document.addEventListener("click", function (e) {
      var btn = e.target.closest('[data-add-to-cart],[data-buy-now],button[name="add"],#add_to_cart');
      if (btn && form && form.contains(btn)) guard(e);
    }, true);
    if (form) form.addEventListener("submit", guard, true);

    mount.style.display = "";
    showPreview(false);
    sync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
